export class CopyEmail {
  constructor() {
    this.init();
  }

  init() {
    const copyBtn = document.querySelector('.copy-email-btn');
    if (!copyBtn) return;

    copyBtn.addEventListener('click', this.handleCopy.bind(this));
    
    // Support touch events for iOS
    copyBtn.addEventListener('touchend', this.handleCopy.bind(this));
    
    // Support keyboard activation
    copyBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handleCopy.call(this, e);
      }
    });
  }

  async handleCopy(event) {
    const btn = event.currentTarget;
    const email = btn.dataset.email;
    
    if (!email) return;

    // Prevent default behavior and stop propagation
    event.preventDefault();
    event.stopPropagation();

    // Immediate visual feedback
    this.showProcessing(btn);

    try {
      // Try modern Clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(email);
        this.showSuccess(btn);
      } else {
        // Fallback for older browsers or non-HTTPS
        this.fallbackCopy(email);
        this.showSuccess(btn);
      }
    } catch (error) {
      console.warn('Copy failed, trying fallback:', error);
      try {
        this.fallbackCopy(email);
        this.showSuccess(btn);
      } catch (fallbackError) {
        console.error('All copy methods failed:', fallbackError);
        this.showError(btn);
      }
    }
  }

  fallbackCopy(text) {
    // Create temporary textarea for copying
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-999999px';
    textarea.style.top = '-999999px';
    
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    
    const successful = document.execCommand('copy');
    document.body.removeChild(textarea);
    
    if (!successful) {
      throw new Error('Fallback copy failed');
    }
  }

  showProcessing(btn) {
    const btnText = btn.querySelector('.copy-btn-text');
    btn.classList.add('processing');
    if (btnText) {
      btnText.textContent = 'Copia...';
    }
  }

  showSuccess(btn) {
    const btnText = btn.querySelector('.copy-btn-text');
    const originalBtnText = btnText ? btnText.dataset.originalText || 'Copia mail' : null;
    
    // Store original text if not already stored
    if (btnText && !btnText.dataset.originalText) {
      btnText.dataset.originalText = btnText.textContent;
    }
    
    // Update button state
    btn.classList.remove('processing');
    btn.classList.add('copied');
    if (btnText) {
      btnText.textContent = 'Copiato!';
    }
    
    // Reset after 3 seconds (longer for mobile)
    setTimeout(() => {
      btn.classList.remove('copied');
      if (btnText && originalBtnText) {
        btnText.textContent = originalBtnText;
      }
    }, 3000);
  }

  showError(btn) {
    const btnText = btn.querySelector('.copy-btn-text');
    const originalBtnText = btnText ? btnText.dataset.originalText || 'Copia mail' : null;
    
    btn.classList.remove('processing');
    btn.classList.add('error');
    
    if (btnText) {
      btnText.textContent = 'Errore copia';
    }
    
    // Reset after 3 seconds
    setTimeout(() => {
      btn.classList.remove('error');
      if (btnText && originalBtnText) {
        btnText.textContent = originalBtnText;
      }
    }, 3000);
  }
}